import { useStore } from "../../../../store/store";
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes";
import { TrackingFlowTypeEnum } from "../../../../types/TrackingFlowTypeEnum";
import { salespersonOptions } from "../../../../constants/Salespersons";
import Accordion from "../../components/Accordion";
import SelectVF from "../../components/SelectVF";
import { Paragraph } from "./SalespersonStep.style";

export default function SalespersonStep() {
  const setAccordionRoute = useStore.useSetAccordionRoute();
  const setCompletedAccordionRoute = useStore.useSetCompletedAccordionRoute();
  const payload = useStore.usePayload();
  const setPayload = useStore.useSetPayload();

  const goToNextStep = () => {
    setCompletedAccordionRoute(AccordionRoutesEnum.SalespersonStep);
    setAccordionRoute(AccordionRoutesEnum.OccupationStep, payload, TrackingFlowTypeEnum.Vertical);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <Accordion
      title="Vælg konsulent"
      step={AccordionRoutesEnum.SalespersonStep}
      onNext={goToNextStep}
      stepComplete={payload.salesperson ? true : false}
      headerImg="/assets/images/icon-article.svg"
    >
      <SelectVF
        id="chooseSalesperson"
        name="salesperson"
        options={salespersonOptions}
        placeholder="Vælg konsulent"
        label="Konsulentens navn"
        selectedOption={payload.salesperson}
        step={AccordionRoutesEnum.SalespersonStep}
        onSelect={(id) => {
          setPayload({ salesperson: id });
          goToNextStep();
        }}
      />
    </Accordion>
  );
}
